import React from "react";
import { Checkbox, Box } from "@mui/material";

const CustomCheckbox = ({ checked, onChange, indeterminate = false }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        indeterminate={indeterminate}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "4px",
                    border: "1px solid #D0D5DD",
                    backgroundColor: "#E5E8EB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "4px",
                    backgroundColor: "#1976d2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);

export default CustomCheckbox;